import { Module } from "vuex";
import { RootState } from "../index";
import {
  getUser,
  getRoles,
  deleteRoles,
  updateUser,
} from "@/shared/api/permissions";
import { ElMessage } from "element-plus";
import { IUser } from "@/shared/types/permissions";

export interface IState {
  users: IUser[];
  roles: [];
}

const permissionsModule: Module<IState, RootState> = {
  namespaced: true,
  state: {
    users: [],
    roles: [],
  },
  mutations: {
    SET_LIST(state, users = []) {
      state.users = users;
    },
    SET_ROLES(state, roles = []) {
      state.roles = roles;
    },
    DELETE_ITEM_FROM_LIST(state, id) {
      state.users = state.users.filter((item) => item.id !== id);
    },
    UPDATE_ITEM_IN_LIST(state, data) {
      state.users = state.users.map((item) => {
        if (item.id === data.id) {
          return { ...data };
        }
        return item;
      });
    },
  },
  actions: {
    async getUsers({ commit }) {
      try {
        const { data } = await getUser();
        commit("SET_LIST", data || []);
      } catch (e) {
        console.error(e);
      }
    },
    async getRoles({ commit }) {
      try {
        const { data } = await getRoles();
        commit("SET_ROLES", data || []);
      } catch (e) {
        console.error(e);
      }
    },
    async deleteRoles({ commit }, payload) {
      try {
        const res = await deleteRoles(payload);
        if (res.code === 200) {
          commit("UPDATE_ITEM_IN_LIST", res.data);
          ElMessage({
            message: "User deleted successfully",
            type: "success",
          });
        } else {
          ElMessage({
            message: res.message,
            type: "error",
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    async updateUser({ commit }, payload) {
      try {
        const res = await updateUser(payload);
        commit("UPDATE_ITEM_IN_LIST", res.data);
        if (res.code === 200) {
          ElMessage({
            message: "Operation was successful",
            type: "success",
          });
        } else {
          if (res.code === 422) {
            ElMessage({
              message: res.message,
              type: "error",
            });
          } else {
            ElMessage({
              message: "Something went wrong",
              type: "error",
            });
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
};

export default permissionsModule;
